<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">
                Conversion de Producto #
                <u>{{ current.numero }}</u>
                &nbsp;
                <div
                  class="badge"
                  :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }"
                >
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{
                    current.estado_str
                  }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <!-- <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button> -->
                    &nbsp;

                    <div class="btn-group">
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          @click="showModalTiendaDuplicar"
                          :disabled="current.estado != 'B'"
                          href="#"
                        >
                          <i class="fas fa-copy"></i>
                          Duplicar La Conversión
                        </button>
                        <button
                          class="dropdown-item"
                          :class="{ disabled: !(current.estado == 'B') }"
                          @click="abrir"
                          :disabled="!(current.estado == 'B')"
                          href="#"
                        >
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="cerrar"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                        >
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="anular"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="generarSalidaPosAntiguo"
                          :disabled="current.estado != 'B'"
                          href="#"
                        >
                          <i class="fas fa-upload"></i>
                          Generar salida en POS antiguo
                        </button>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
                >{{ current.errors.detail }}</small
              >
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Código</label>
                    <input
                      v-model="current.producto.sku"
                      autofocus="autofocus"
                      class="form-control"
                      placeholder="Código Producto"
                      type="text"
                      :disabled="true"
                    />
                    <small
                      v-if="current.errors && current.errors.motivo_ajuste"
                      class="form-text text-danger"
                      >{{ current.errors.motivo_ajuste[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Nombre Producto</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.producto.nombre"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Cantidad</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.cantidad"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <TiendaSelectComponent :current="current" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Usuario</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.usuario"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.fecha,
                      }"
                      >Fecha</label
                    >
                    <input
                      v-model="current.fecha"
                      class="form-control"
                      placeholder="Fecha"
                      :disabled="true"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.fecha"
                      class="form-text text-danger"
                      >{{ current.errors.fecha[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <div class="table-responsive" v-if="current.id != null">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Producto</th>
                      <th>Lote</th>
                      <th>Posición</th>
                      <th class="text-center" style="width: 100px">Unidades</th>
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="detalle in current.conversiond_set"
                      v-bind:key="detalle.id"
                    >
                      <td>{{ detalle.producto.sku }}</td>
                      <td>{{ detalle.producto.nombre }}</td>
                      <td>
                        {{ detalle.producto_lote.codigo_lote }} ||
                        {{ detalle.producto_lote.fecha_vence }}
                      </td>
                      <td>
                        {{ detalle.tienda_posicion.posicion }}
                      </td>
                      <td
                        class="text-right bolder nowrap"
                        style="font-weight: 500"
                      >
                        <span v-if="current.estado == 'B'">
                          {{ detalle.cantidad }}</span
                        >
                        <div
                          class="input-group input-group-sm"
                          v-if="current.estado == 'A'"
                        >
                          <div class="input-group-prepend"></div>
                          <input
                            v-on:keyup.enter="modificarDetalle(detalle)"
                            v-if="current.estado == 'A'"
                            class="form-control text-right"
                            v-model="detalle.cantidad"
                            placeholder="cantidad"
                            type="text"
                          />
                          <div class="input-group-append"></div>
                        </div>
                      </td>
                      <td class="text-center" style="width: 100px">
                        <button
                          class="btn btn-sm btn-success"
                          type="button"
                          v-if="current.estado == 'A'"
                          @click="modificarDetalle(detalle)"
                        >
                          <i class="far fa-save"></i>
                        </button>
                        <button
                          class="btn btn-sm btn-danger"
                          type="button"
                          v-if="current.estado == 'A'"
                          @click="eliminarDetalle(detalle)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    @click="showModalAddDetail"
                    v-if="current.estado == 'A'"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar Producto Equivalente
                  </button>
                </div>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="current.estado == 'A'"
                  @click="guardar(current)"
                >
                  Guardar
                </button>
                <router-link
                  class="btn btn-outline-info"
                  :to="{ name: 'inventario-conversiones' }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Listado de Ajustes
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailReqTraslado"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 mb-1">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors &&
                          currentDetalle.errors.producto,
                      }"
                      >Producto</label
                    >
                    <v-select
                      label="nombre"
                      v-model="currentDetalle.producto"
                      :filterable="false"
                      :options="productos"
                      @search="onSearchProducto"
                      @input="setSelected"
                    >
                      <template slot="no-options">Producto...</template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                    </v-select>
                    <small
                      v-if="
                        currentDetalle.errors && currentDetalle.errors.producto
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.producto[0] }}</small
                    >
                  </div>
                </div>
                <div
                  v-if="
                    currentDetalle.productolote_set != null &&
                    currentDetalle.productolote_set.length > 0
                  "
                  class="col-sm-12 mb-1"
                >
                  Lotes:
                  <select
                    v-model="currentDetalle.codigo_lote"
                    class="form-control"
                    autofocus="autofocus"
                  >
                    <option
                      v-for="detalle in currentDetalle.productolote_set"
                      :value="detalle.id"
                      v-bind:key="detalle.id"
                    >
                      Lote: {{ detalle.codigo_lote }} || Vence:
                      {{ detalle.fecha_vence }}
                    </option>
                  </select>
                </div>
                <div class="col-12">
                  Posicion:
                  <select
                    v-model="currentDetalle.posicion"
                    class="form-control"
                  >
                    <option
                      v-for="detalle in posiciones"
                      :value="detalle.posicion_id"
                      v-bind:key="detalle.id"
                    >
                      {{ detalle.codigo_barra }}
                    </option>
                  </select>
                  <small
                    v-if="
                      currentDetalle.errors && currentDetalle.errors.posicion
                    "
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.posicion }}</small
                  >
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors &&
                          currentDetalle.errors.cantidad,
                      }"
                      >Cantidad en Unidades</label
                    >
                    <input
                      v-on:keyup.enter="agregaDetalle"
                      v-model="currentDetalle.cantidad"
                      class="form-control"
                      placeholder="Cantidad"
                      type="text"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        currentDetalle.errors && currentDetalle.errors.cantidad
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="agregaDetalle"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddTiendaDuplicar"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Elegir Tienda</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent :current="duplicar" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="duplicarConversion(duplicar)"
              type="button"
            >
              Generar Duplicación
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        motivo_ajuste: "",
        errors: [],
        producto: {},
      },
      duplicar: {},
      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],

      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],

      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        posicion: "",
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
  },
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent(this.$route.params.id);
    }
    self.refreshPosiciones();
  },
  methods: {
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        self.currentDetalle.codigo_lote = res.data.productolote_set[0].id;
      });
    },
    generarSalidaPosAntiguo() {
      let self = this;
      Notifications.alert.confirm(
        "¡IMPORTANTE!",
        "Esta acción solo se debe de realizar una vez por cada conversión",
        "",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "generar_ajuste_inv"
          ).then((response) => {
            Notifications.alert.success(
              "Salida de Inventario en POS antiguo",
              "Generado Satifactoriamente"
            );
          });
        }
      );
    },
    showModalTiendaDuplicar() {
      $("#modalAddTiendaDuplicar").modal();
    },
    duplicarConversion(duplicar) {
      let self = this;
      if (!duplicar.tienda) {
        Notifications.alert.info("¡Atencion!", "La tienda no puede ir nula");
        return;
      }
      self.tienda = duplicar.tienda;
      Notifications.alert.confirm(
        "Nota",
        "Si realiza esta acción se duplicara toda la información de la conversión ¿Esta de acuerdo?",
        "",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "duplicar",
            { tienda: duplicar.tienda }
          )
            .then((response) => {
              Notifications.alert.success(
                "Duplicar Conversión",
                "Realizado con éxito"
              );
              self.id = response.data.conversion_e;
              self.$router.push({
                name: "inventario-conversiones-editar",
                params: { id: self.id },
              });
              $("#modalAddTiendaDuplicar").modal("hide");
              self.refreshCurrent();
              self.refreshDetalleDefault();
            })
            .catch((error) => {
              Notifications.alert.error("Duplicar", error.response.data.detail);
            });
        }
      );
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("inv", "conversion-e", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.tienda = response.data.tienda.codigo;
          self.current.usuario = response.data.usuario.name;
        }
      );
    },
    refreshPosiciones() {
      let self = this;
      let params = {
        page: 1,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      PosicionesService.fetch(params).then((res) => {
        self.posiciones = res.data;
      });
    },
    guardar(current) {
      let self = this;
      if (current.producto) {
        current.producto = current.producto.sku;
      }
      DynamicService.save("inv", "conversion-e", current).then((response) => {
        Notifications.alert.success(
          "Conversión",
          "Se ha guardado la información"
        );
        self.refreshCurrent();
      });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },
    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      PosicionesService.fetch({
        page: 1,
        tienda: self.current.tienda,
        activo: true,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalAddDetailReqTraslado").modal();
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      DynamicService.postAction(
        "inv",
        "conversion-e",
        self.current.id,
        "agregar_detalle",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Producto Equivalente",
            "Se ha guardado la Información."
          );
          $("#modalAddDetailReqTraslado").modal("hide");
          self.busqueda_posicion = "";
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
    },
    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Producto Equivalente",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "eliminar_detalle",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Producto Equivalente",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    modificarDetalle(detalle) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "conversion-e",
        self.current.id,
        "modificar_detalle",
        detalle
      )
        .then((response) => {
          Notifications.alert.success("Información", "Guardado Correctamente");
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Conversión de Producto",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "abrir"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conversión de Producto",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Conversión de Producto",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conversión de Producto",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Conversión de Producto",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "anular"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conversión de Producto",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      self.duplicar = {};
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    // imprimir() {
    //   let self = this;
    //   AjusteInventarioService.pdf(self.current.id)
    //     .then((response) => {
    //       console.log(response.data.output);
    //       window.open(response.data.output);
    //     })
    //     .catch((error) => {
    //       Notifications.alert.error(
    //         "No se ha podido realizar la acción",
    //         error.response.data.detail
    //       );
    //     });
    // },
  },
};
</script>
